import { IPublicAvailableShiftsData } from '@pharmaplan/common/models/Models';
import { ProfessionalReplacementTypes, TimeFormat } from '@pharmaplan/common';
import { DynamicTableCell, ReplacementLabels } from '../../helpers/Constants';
import { timeString } from '../../helpers/Functions';
import { getDayMonthDateYear } from '../Reports/helpers';
import strings from '../../localization';

const { text, button } = DynamicTableCell;

export const availableShiftHeader = () =>
  [
    {
      key: '0',
      label: strings.city,
    },
    {
      key: '1',
      label: strings.hours,
      isCenterAligned: true,
    },
    {
      key: '2',
      label: strings.date,
      isCenterAligned: true,
    },
    {
      key: '3',
      label: strings.role,
    },
    {
      key: '4',
      isCenterAligned: true,
      label: strings.action,
    },
  ];

export const availableShiftMapper = (data: Array<IPublicAvailableShiftsData>, handleNavigate: () => void, isFrench?: boolean) =>
  data?.map((item) => {
    const { startDate, endDate, city, role, workShiftId } = item ?? {};
    const hours = timeString(startDate, endDate, TimeFormat.twentyFourHours);
    const date = getDayMonthDateYear(startDate);
    const labels = {
      [ProfessionalReplacementTypes.pharmacist]: strings.pharmacist,
      [ProfessionalReplacementTypes.technician]: strings.technician,
      [ProfessionalReplacementTypes.student]: strings.pharmacyStudent,
    };

    return {
      key: workShiftId,
      data: [
        {
          key: 1,
          value: city,
          type: text,
        },
        {
          key: 2,
          value: hours,
          type: text,
          isCenterAligned: true,
        },
        {
          key: 3,
          value: date,
          type: text,
          isCenterAligned: true,
        },
        {
          key: 4,
          value: labels[role],
          type: text,
        },
        {
          key: 5,
          show: true,
          value: {
            label: strings.requestBooking,
            style: {
              maxWidth: isFrench ? 250 : 150,
            },
            handlePress: handleNavigate,
          },
          isCenterAligned: true,
          type: button,
        },
      ],
    };
  });
